import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'src/app/api';
import { buildEncodedQueryString } from 'src/common';
import { AssetClassOrderItem, Afsl, FetchAfslIdsResponse, FetchAssetClassOrderPayload, UpsertAssetClassOrderPayload } from './types';

export enum AssetClassOrderTypes {
  FetchAssetClassOrder = '@@client/securities/report-settings/Fetch',
  UpsertAssetClassOrder = '@@client/securities/report-settings/Upsert',
  FetchAfsls = '@@client/securities/report-settings/FetchAsflIds',
}

export enum AssetClassOrderEndpoints {
  FetchAssetClassOrder = '/securities/GetAssetClassOrder',
  UpsertAssetClassOrder = '/securities/UpsertAssetClassOrder',
  FetchAfsls = '/bff/GetAfslsPracticesAdvisersForUser',
}

export const fetchAssetClassOrder = createAsyncThunk(AssetClassOrderTypes.FetchAssetClassOrder, async ({ afslId }: FetchAssetClassOrderPayload) => {
  const queryString = buildEncodedQueryString({
    afslId,
  });

  const response = await api.get<AssetClassOrderItem[]>(`${AssetClassOrderEndpoints.FetchAssetClassOrder}${queryString}`);

  return response.data;
});

export const upsertAssetAllocationOrder = createAsyncThunk(
  AssetClassOrderTypes.UpsertAssetClassOrder,
  async (payload: UpsertAssetClassOrderPayload, thunkApi) => {
    await api.post<number>(`${AssetClassOrderEndpoints.UpsertAssetClassOrder}`, payload);

    await thunkApi.dispatch(fetchAssetClassOrder({ afslId: payload.afslId }));

    return { message: 'Report Asset allocation order updated ...' };
  }
);

export const fetchAfsls = createAsyncThunk<Afsl[]>(AssetClassOrderTypes.FetchAfsls, async () => {
  const response = await api.get<FetchAfslIdsResponse>(AssetClassOrderEndpoints.FetchAfsls);
  return response.data.afsls.map((a) => ({ id: a.afslId, name: a.afslName }));
});
